var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmbedLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000005364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 12.0266V20.0267C11.9392 20.0267 10.9217 19.6052 10.1716 18.8551C9.42143 18.1049 9 17.0875 9 16.0266C9 14.9658 9.42143 13.9483 10.1716 13.1982C10.9217 12.448 11.9392 12.0266 13 12.0266Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 12C12.9999 9.79088 14.7908 8 17 8C19.2091 8 21 9.79088 21 12V20.0001C21 22.2093 19.2091 24.0002 17 24.0002C14.7997 24.0002 13.0144 22.2236 13 20.0267C15.2092 20.0266 17 18.2359 17 16.0267C17 13.8176 15.2092 12.0266 13 12.0266L12.9999 12Z",
    fill: "white",
    fillOpacity: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedLogo);
export default __webpack_public_path__ + "static/media/embed-logo.6ad3077999beb5d62d072315d12efcf9.svg";
export { ForwardRef as ReactComponent };